import React from 'react';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CircularProgress from '@material-ui/core/CircularProgress';
import parseJson from 'parse-json';

// https://github.com/fontsource/fontsource/blob/master/packages/roboto/README.md
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';

import theme from '../../utils/theme';
import HomePage from '../../pages/HomePage';
import FichesPage from '../../pages/FichesPage';

const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      error: null,
    };
  }

  componentDidMount() {
    fetch('./data.json', { cache: 'no-store' })
      .then(r => r.text())
      .then(json => {
        try {
          const data = parseJson(json);
          this.setState({ data });
        } catch (error) {
          this.setState({ error });
        }
      });
  }

  renderError() {
    const { error } = this.state;
    if (!error) {
      return null;
    }
    return (
      <div style={{ padding: 30 }}>
        <h2>Erreur dans le parsing du fichier</h2>
        <pre>{error.message}</pre>
      </div>
    );
  }

  renderLoading() {
    const { data, error } = this.state;
    if (data || error) {
      return null;
    }
    return (
      <div style={{ width: '100%', paddingTop: '35vh', textAlign: 'center' }}>
        <h1 style={{ width: '100%', textAlign: 'center', marginBottom: 50 }}>Chargement...</h1>
        <CircularProgress />
      </div>
    );
  }

  renderApp() {
    const { data, error } = this.state;
    if (!data || error) {
      return null;
    }
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path={`${BASE_URL}/`}>
            <HomePage data={data} />
          </Route>
          <Route exact path={`${BASE_URL}/fiches`}>
            <FichesPage data={data} />
          </Route>
          <Route path="*">
            <div style={{ width: '100%', paddingTop: '35vh', textAlign: 'center' }}>
              <h1 style={{ width: '100%', textAlign: 'center', marginBottom: 50 }}>404 - Not Found</h1>
              <Link to={`${BASE_URL}/`} style={{ color: '#888' }}>
                Retour à la page d’accueil
              </Link>
            </div>
          </Route>
        </Switch>
      </BrowserRouter>
    );
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {this.renderLoading()}
        {this.renderError()}
        {this.renderApp()}
      </ThemeProvider>
    );
  }
}

export default App;
